import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { financecommerceApi, type Settlement } from '../../api/financecommerce';

export function SettlementDashboardPage() {
  const [items, setItems] = useState<Settlement[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void financecommerceApi.listSettlements().then(setItems);
  }, []);

  async function importSample() {
    const now = new Date();
    const stl = await financecommerceApi.importSettlement({
      marketplace: 'amazon',
      period_start: new Date(now.getTime() - 7 * 86400000).toISOString(),
      period_end: now.toISOString(),
      transactions: [{ order_id: 'O1', type: 'sale', amount: 15000 }],
      fees: [{ fee_code: 'commission', amount: 2700 }],
    });
    await financecommerceApi.processSettlement(stl.id);
    setMsg(`Imported ${stl.settlement_number}`);
    setItems(await financecommerceApi.listSettlements());
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/finance" className="text-sm text-slate-600 hover:underline">← Finance hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Settlement dashboard</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <button type="button" onClick={() => void importSample()}
        className="mt-4 rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Import sample settlement</button>
      <ul className="mt-6 space-y-2">
        {items.map((s) => (
          <li key={s.id} className="rounded border p-3 text-sm">
            {s.settlement_number} — {s.marketplace} · {s.status} · Net ₹{s.net_amount}
          </li>
        ))}
      </ul>
    </div>
  );
}
